<template>
	<div class="tiaojie">
		<!-- class="container" -->
		<div>
			<Nav :currentPage='curpage'></Nav>
			<!-- 轮播图 -->
			<section class="carousel-container">
				<div id="carousel-example-generic" class="carousel slide my-slide" data-ride="carousel">
					<div class="carousel-inner">
						<div class="item" :class="{active: index=='0'}" v-for="(item, index) in bannerList" :key="index">
							<img :src="item.picture_url" alt style="max-width: 100%;margin: 0 auto;" />
							<div class="carousel-caption" v-if="item.tile !=''">{{item.title}}</div>
						</div>
					</div>
					<!-- 左右箭头 -->
					<!-- <a href="#carousel-example-generic" class="left carousel-control" data-slide="prev">
						<span class="glyphicon glyphicon-chevron-left"></span>
					</a>
					<a href="#carousel-example-generic" class="right carousel-control" data-slide="next">
						<span class="glyphicon glyphicon-chevron-right"></span>
					</a> -->
				</div>
			</section>

			<div class="diwen1">
				<section class="section1">
					<div class="sec1_title">
						<p>互联网时代背景下</p>
						<p>矛盾纠纷多元化解工作面临的困境</p>
					</div>
					<div class="sec_con">
						<div class="sec_con_item">
							<div class="item">
								<img src="../../assets/images/tiaojie_1.png" class="img_tiaojie1" />
								<div class="content">
									<p class="bolder">社会矛盾纠纷逐渐增多</p>
									<p>社会矛盾纠纷呈增长快、燃点低、</p>
									<p>处置难、对抗强等趋势</p>
								</div>
							</div>

							<div class="item">
								<img src="../../assets/images/tiaojie_2.png" class="img_tiaojie1" />
								<div class="content">
									<p class="bolder">传统纠纷化解模式滞后</p>
									<p>传统纠纷化解模式制约多、耗时长、</p>
									<p>复杂性、高成本、效果有限</p>
								</div>
							</div>
						</div>

						<div class="sec_con_item">
							<div class="item right_item">
								<div class="content">
									<p class="bolder">社会矛盾纠纷常变常新</p>
									<p>社会矛盾纠纷呈跨地域、时效强、</p>
									<p>影响大、不确定性较大等特征</p>
								</div>
								<img src="../../assets/images/tiaojie_3.png" class="img_tiaojie1" />
							</div>

							<div class="item right_item">
								<div class="content">
									<p class="bolder">基层调解组织面临难题</p>
									<p>人员构成混杂、素质层次不齐、</p>
									<p>上级监管困难、部门联动不畅</p>
								</div>
								<img src="../../assets/images/tiaojie_4.png" class="img_tiaojie1" />
							</div>
						</div>
					</div>
				</section>

				<section class="section1 section2">
					<div class="sec1_title">
						<p>互联网+矛盾纠纷多元化解</p>
						<p>是时代所趋</p>
					</div>
					<div class="sec2_con">
						<div class="sec2_img"><img src="../../assets/images/tiaojie_5.png" alt="" class="img_tiaojie_5"></div>
						<div class="sec2_ul">
							<p class="li_1"><i class="icon_sanjiao"></i>顺应信息时代发展趋势，满足民众解纷需求</p>
							<p class="li_2"><i class="icon_sanjiao"></i>推动“三调联动”，再造多元解纷机制</p>
							<p class="li_3"><i class="icon_sanjiao"></i>破解“案多人少”矛盾，达成溯源治理目标</p>
							<p class="li_4"><i class="icon_sanjiao"></i>回应司法改革要求，实现司法创新发展</p>
						</div>
					</div>
				</section>

				<!-- </div>

			<div class="diwen2"> -->
				<section class="section1">
					<div class="sec1_title">
						<p>六大专业服务</p>
						<p>Six major professional services </p>
					</div>
					<div class="wrapper" ref="wrapper">
						<ul class="w_item" ref="w_item">
							<li v-for="(item, index) in sixServiceList" :key="index" class="li_service" :class="item.aclass">
								<img :src="item.picture_url" alt="" class="img img_pic">
								<img :src="item.img_url" alt="" class="img_icon">
								<p>{{item.title}}</p>
							</li>
						</ul>
					</div>
				</section>

				<section class="section1 section3">
					<div class="sec1_title">
						<p>助力建立健全有机衔接、协调联动、高效便捷的</p>
						<p>矛盾纠纷多元化解机制</p>
					</div>
					<div class="sec2_con jiufen_con">
						<div class="sec2_img"><img src="../../assets/images/tiaojie_9.png" alt="" class="img_tiaojie_9"></div>
						<div class="sec2_ul jiufen_ul">
							<p class="title_1">社会矛盾纠纷逐渐增多</p>
							<p class="title_2">移动化、智能化、场景化的技术构架</p>
							<p class="title_3">充分利用大数据、AI人工智能和区块链技术，推动矛盾纠纷多元化解机制的“供给侧改革”，实现方便纠纷当事人获取调解资源、方便人民调解员提升调解质效。</p>
						</div>
					</div>
					<div class="sec2_con jiufen_con">
						<div class="sec2_ul jiufen_ul jiufen_ul_left">
							<p class="title_1">社会矛盾纠纷逐渐增多</p>
							<p class="title_2">移动化、智能化、场景化的技术构架</p>
							<p class="title_3">充分利用大数据、AI人工智能和区块链技术，推动矛盾纠纷多元化解机制的“供给侧改革”，实现方便纠纷当事人获取调解资源、方便人民调解员提升调解质效。</p>
						</div>
						<div class="sec2_img"><img src="../../assets/images/tiaojie_10.png" alt="" class="img_tiaojie_10"></div>
					</div>
					<div class="sec2_con jiufen_con">
						<div class="sec2_img"><img src="../../assets/images/tiaojie_11.png" alt="" class="img_tiaojie_11"></div>
						<div class="sec2_ul jiufen_ul">
							<p class="title_1">传统纠纷化解模式滞后</p>
							<p class="title_2">全天候、一体化、普惠式的创新模式</p>
							<p class="title_3">以核心科技——法律知识图谱和构建、电子卷宗识别和信息提取、在线音视频调解、司法大数据融合、法律大数据画像等开展矛盾纠纷排查预防、分析研判、调处化解，满足群众多元解纷需求。
							</p>
						</div>
					</div>
					<div class="sec2_con">
						<div class="sec2_ul jiufen_ul jiufen_ul_left">
							<p class="title_1">基层调解组织面临难题</p>
							<p class="title_2">专业化、集约化、数据化的运维管理</p>
							<p class="title_3">推进基层调解组织上下联动、内外贯通，发挥信息联通、纠纷联排、力量联动、矛盾联调等功效，实现全程留痕、动态监督、评价考核、智能辅助，形成共建共治共享的社会治理新格局。</p>
						</div>
						<div class="sec2_img"><img src="../../assets/images/tiaojie_12.png" alt="" class="img_tiaojie_12"></div>
					</div>
				</section>
			</div>

			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import BScroll from 'better-scroll'
import Footer from 'components/footer.vue'
import Nav from 'components/nav.vue'
/*global require*/

export default {
  name: 'Home',
  data() {
    return {
      curpage: 'product',
      bannerList: [
        {
          picture_url: require('../../assets/images/tiaojie_banner.png'),
          title: ''
        }
      ],
      sixServiceList: [
        {
          picture_url: require('../../assets/images/tiaojie_6.png'),
          img_url: require('../../assets/images/tiaojie_camera.png'),
          aclass: 'li_service_1',
          title: '在线音视频调解系统'
        },
        {
          picture_url: require('../../assets/images/tiaojie_7.png'),
          img_url: require('../../assets/images/tiaojie_ai.png'),
          aclass: 'li_service_2',
          title: '人工智能咨询'
        },
        {
          picture_url: require('../../assets/images/tiaojie_8.png'),
          img_url: require('../../assets/images/tiaojie_jz.png'),
          aclass: 'li_service_3',
          title: '卷宗自动生成'
        },
        {
          picture_url: require('../../assets/images/tiaojie_13.png'),
          img_url: require('../../assets/images/tiaojie-icon_maodun.png'),
          aclass: 'li_service_4',
          title: '矛盾纠纷大数据分析'
        },
        {
          picture_url: require('../../assets/images/tiaojie-dianzi.png'),
          img_url: require('../../assets/images/tiaojie-icon_dianzi.png'),
          aclass: 'li_service_5',
          title: '电子数据存证'
        },
        {
          picture_url: require('../../assets/images/tiaojie-leian.png'),
          img_url: require('../../assets/images/tiaojie-icon_leian.png'),
          aclass: 'li_service_6',
          title: '类案判决预测'
        }
      ],
      clientWidth: document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onresize = () => {
        this.clientWidth = document.documentElement.clientWidth || document.body.clientWidth
      }
      console.log(this.clientWidth)
      this.initScroll()
    })
  },
  created() {
    console.log()
    this.$nextTick(() => {
      this.initScroll()
    })
  },
  methods: {
    initScroll() {
      // 我要办理
      var that = this
      var width = 0
      if (this.clientWidth > 768) {
        width = this.sixServiceList.length * 300
      } else {
        width = this.sixServiceList.length * 260
      }
      this.$refs.w_item.style.width = width + 'px'
      this.$nextTick(() => {
        if (!that.scroll) {
          that.scroll = new BScroll(this.$refs.wrapper, {
            startX: 0,
            scrollX: true,
            scrollY: false,
            click: true,
            eventPassthrough: 'vertical'
          })
        } else {
          that.scroll.refresh()
        }
      })
    }
  },
  components: {
    Footer,
    Nav
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 200px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}
.tiaojie {
	margin: 0 auto;
}
.img_banner {
	width: 100%;
	height: 100%;
}
// .container {
// 	padding: 0;
// 	margin: 0 auto;
// 	position: relative;
// 	.diwen2 {
// 		background: url('../../assets/images/tj_diwen2.png') no-repeat 50%;
// 		height: 2764px;
// 	}
// }
.diwen1 {
	background: url('../../assets/images/tiaojie_bkg.png') no-repeat 50%;
	margin: 0 auto;
}
.section1 {
	width: 930px;
	margin: 110px auto 150px;
	text-align: center;
}
.section2 {
	width: 990px;
}
.section3 {
	width: 997px;
}
.section4 {
	width: 890px;
}
.sec1_title {
	position: relative;
	p {
		padding: 0;
		font-size: 30px;
		color: #000;
	}
}
.sec1_title::after {
	content: '';
	position: absolute;
	top: 120%;
	left: 46%;
	width: 94px;
	height: 5px;
	background: #0066ff;
}
.sec_con {
	width: 100%;
	margin: 150px auto 0;
	position: relative;
	.sec_con_item {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-bottom: 94px;
		.right_item {
			.content {
				padding-left: 0 !important;
				padding-right: 30px;
			}
		}
		.item {
			box-sizing: border-box;
			position: relative;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			.img_tiaojie1 {
				flex: 0 0 122px;
				width: 122px;
				height: 78px;
			}
			.content {
				flex: 1;
				text-align: left;
				padding-left: 30px;
			}
			.content p {
				margin: 0 0 6px;
				font-size: 14px;
			}
			.content .bolder {
				font-size: 18px;
				font-weight: 600;
			}
		}
	}
}

.sec2_con {
	width: 100%;
	margin-top: 80px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	.sec2_img {
		flex: 1;
		.img_tiaojie_5 {
			width: 402px;
			height: 449px;
		}
		.img_tiaojie_9 {
			width: 400px;
			height: 278px;
		}
		.img_tiaojie_10 {
			width: 332px;
			height: 377px;
			margin-left: 136px;
			margin-top: -60px;
		}
		.img_tiaojie_11 {
			width: 223px;
			height: 288px;
		}
		.img_tiaojie_12 {
			width: 349px;
			height: 319px;
		}
	}
	.sec2_ul {
		margin-top: 55px;
		flex: 1;
		text-align: left;
		padding-left: 58px;
		font-size: 14px;
		color: #000;
		p {
			margin-bottom: 82px;
			padding-left: 20px;
			position: relative;
			.icon_sanjiao {
				position: absolute;
				top: 3px;
				left: 0;
				width: 12px;
				height: 14px;
				background: url('../../assets/images/tj_sanjiao.png') no-repeat;
			}
		}
		.li_2 {
			padding-left: 122px;
			.icon_sanjiao {
				left: 19%;
			}
		}
		.li_3 {
			padding-left: 190px;
			.icon_sanjiao {
				left: 32%;
			}
		}
	}

	.jiufen_ul {
		margin-top: 18px;
		text-align: right;
		p {
			margin-bottom: 20px;
			line-height: 36px;
		}
		.title_1 {
			font-size: 16px;
			color: #0066ff;
		}
		.title_2 {
			font-size: 15px;
			color: #727171;
		}
		.title_3 {
			text-align: left;
			text-indent: 20px;
			font-size: 14px;
			color: #727171;
		}
	}

	.jiufen_ul_left {
		text-align: left;
		padding-left: 0;
	}
}

.jiufen_con {
	margin-bottom: 180px;
}

.wrapper {
	width: 100%;
	margin-top: 76px;
	padding: 10px;
	box-sizing: border-box;
	touch-action: none;
	overflow-x: scroll;
	overflow: hidden;
	.w_item {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: nowrap;
		margin-bottom: 10px;
		padding-inline-start: 6px;
		.li_service:first-child {
			margin-left: 0;
		}
		.li_service {
			width: 300px;
			background: #ffffff;
			box-shadow: 0 0 6px rgba(185, 188, 193, 0.4);
			text-align: center;
			font-size: 12px;
			color: #000000;
			border-radius: 10px;
			text-align: center;
			margin-left: 54px;
			padding: 30px 30px 10px;
			position: relative;
			p {
				margin-top: 16px;
				font-size: 13px;
				color: #000;
			}
		}
		.li_service_1 {
			.img_pic {
				display: block;
				width: 199px;
				height: 168px;
				margin: 0 auto 66px;
			}
			.img_icon {
				width: 22px;
				height: 15px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 58px;
				margin: 0;
			}
		}
		.li_service_2 {
			.img_pic {
				display: block;
				width: 217x;
				height: 188px;
				margin: 0 auto 28px;
			}
			.img_icon {
				width: 25px;
				height: 25px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 77px;
				margin: 0;
			}
		}
		.li_service_3 {
			.img_pic {
				display: block;
				width: 188px;
				height: 197px;
				margin: 0 auto 28px;
			}
			.img_icon {
				width: 25px;
				height: 25px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 68px;
				margin: 0;
			}
		}
		.li_service_4 {
			.img_pic {
				display: block;
				width: 203px;
				height: 172px;
				margin: 0 auto 28px;
			}
			.img_icon {
				width: 25px;
				height: 25px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 93px;
				margin: 0;
			}
		}
		.li_service_5 {
			.img_pic {
				display: block;
				width: 175px;
				height: 245px;
				margin: 0 auto 28px;
			}
			.img_icon {
				width: 22px;
				height: 22px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 22px;
				margin: 0;
			}
		}
		.li_service_6 {
			.img_pic {
				display: block;
				width: 200px;
				height: 200px;
				margin: 0 auto 28px;
			}
			.img_icon {
				width: 28px;
				height: 24px;
				position:absolute;
				bottom: 48px;
				left: 44%;
			}
			p{
				padding-top: 66px;
				margin: 0;
			}
		}
	}
}

@media screen and (min-width: 1200px) {
	.container {
		width: 100%;
	}
}

@media screen and (max-width: 998px) and (min-width: 768px) {
	.section1 {
		width: 750px;
		margin: 60px auto 150px;
		text-align: center;
	}
	.sec1_title {
		p {
			font-size: 26px;
		}
	}
	.sec1_title::after {
		width: 66px;
		height: 3px;
		left: 46%;
	}
	.sec_con {
		width: 780px;
		margin: 100px auto 0;
		.sec_con_item {
			width: 753px;
			justify-content: space-around;
			margin-bottom: 76px;
			.item {
				padding-left: 140px;
				box-sizing: border-box;
				text-align: left;
				position: relative;
				.img_tiaojie1 {
					position: absolute;
					top: -8px;
					left: 16px;
					width: 98px;
					height: 62px;
				}
				.content p {
					margin: 0 0 6px;
					font-size: 12px;
				}
				.content .bolder {
					font-size: 16px;
					font-weight: 600;
				}
			}
		}
	}
}

@media screen and (max-width: 767px) {
	.container {
		.diwen2 {
			height: auto;
		}
	}
	.img_banner {
		width: 100%;
		height: 120px;
	}
	.section1 {
		width: 100%;
		margin: 40px auto;
		text-align: center;
	}
	.sec1_title {
		p {
			padding: 0;
			font-size: 16px;
			color: #000;
		}
	}
	.sec1_title::after {
		// display: none;
		width: 66px;
		height: 3px;
		left: 41%;
	}

	.sec_con {
		width: 78%;
		margin: 46px auto 0;
		.sec_con_item {
			margin-bottom: 12px;
			.item {
				width: 100%;
				margin-bottom: 12px;
				.img_tiaojie1 {
					flex: 0 0 74px;
					width: 74px;
					height: 55px;
				}
				.content {
					p {
						font-size: 12px;
					}
					.bolder {
						font-size: 14px;
					}
				}
			}
		}
	}

	.sec2_con {
		margin-top: 20px;
		flex-wrap: wrap;
		.sec2_img {
			width: 100%;
			flex: 1;
			.img_tiaojie_5 {
				width: 282px;
				height: 314px;
				margin: 0 auto;
			}
		}
		.sec2_ul {
			flex: 0 0 100%;
			margin-top: 24px;
			p {
				margin-bottom: 30px;
			}
			.li_2 {
				padding-left: 20px;
				.icon_sanjiao {
					left: 0;
				}
			}
			.li_3 {
				padding-left: 20px;
				.icon_sanjiao {
					left: 0;
				}
			}
		}
	}

	.wrapper {
		margin-top: 40px;
		.w_item {
			.li_service {
				padding: 16px 16px 10px;
			}
			.li_service_1 {
				position: relative;
				.img_pic {
					width: 140px;
					height: 118px;
					margin: 0 auto 30px;
				}
				.img_icon {
					width: 22px;
					height: 14px;
					position:absolute;
					bottom: 20px;
					left: 40%;
				}
			}
			.li_service_2 {
				.img_pic {
					width: 132px;
					height: 138px;
					margin: 0 auto 30px;
				}
				.img_icon {
					width: 22px;
					height: 22px;
				}
			}
			.li_service_3 {
				.img_pic {
					width: 132px;
					height: 138px;
					margin: 0 auto 30px;
				}
				.img_icon {
					width: 22px;
					height: 22px;
				}
			}
			.li_service_4 {
				.img_pic {
					width: 132px;
					height: 138px;
					margin: 0 auto 30px;
				}
				.img_icon {
					width: 22px;
					height: 22px;
				}
			}
		}
	}

	.sec2_con {
		.sec2_img {
			margin-top: 40px;
			.img_tiaojie_9 {
				width: 280px;
				height: 195px;
				margin: 0 auto;
			}
			.img_tiaojie_10 {
				width: 232px;
				height: 264px;
				margin-left: 0;
				margin-top: 0px;
			}
			.img_tiaojie_11 {
				width: 156px;
				height: 202px;
				margin-left: 0;
				margin-top: 0px;
			}
			.img_tiaojie_12 {
				width: 244px;
				height: 223px;
			}
		}
		.jiufen_ul {
			padding-left: 0;
			text-align: center;
			p {
				margin-bottom: 0px;
				padding: 0 20px;
			}
		}
	}

	.jiufen_con {
		margin-bottom: 40px;
	}
}

// .carousel-control {
// 	display: none;
// }
.carousel-caption {
	bottom: -10px;
}
.el-carousel__indicators--outside {
	display: none;
}
</style>
